import { useState } from 'react';
import { useMutation } from '@apollo/react-hooks';
import useAuth from '../components/AuthContext/useAuth';
import t from '@jetshop/intl';
import { deleteAccount } from '@jetshop/core/data/mutations/accountMutations.gql';
const useDeleteAccountMutation = function useDeleteAccountMutation({ confirmationMessage }) {
    const [mutate] = useMutation(deleteAccount);
    const { logOut } = useAuth();
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState();
    function handleMutationError() {
        setError(t('Something went wrong'));
    }
    function confirmDeletion() {
        const confirmation = window.confirm(confirmationMessage || 'Are you sure you wish to delete your account?');
        if (!confirmation) {
            return;
        }
        mutate()
            .then(r => {
            // response is a boolean. If it is false, `something` went wrong… but we
            // don't have an error from the API to display
            if (r.data.deleteCustomer) {
                setSuccess(true);
                logOut();
            }
            else {
                handleMutationError();
            }
        })
            .catch(err => {
            console.warn(err);
            handleMutationError();
        });
    }
    return { confirmDeletion, success, error };
};
export { useDeleteAccountMutation };
//# sourceMappingURL=useDeleteAccountMutation.js.map